var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMarcao = function SvgMarcao(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.92 10C10.92 10.3125 10.7362 10.6055 10.5187 10.7461L6.91873 13.2461C6.50623 13.5664 5.94748 13.4492 5.66998 13.0195C5.39623 12.5898 5.50873 12.0078 5.92123 11.7188L9.11998 9.5V4.6875C9.11998 4.16797 9.52123 3.75 10.02 3.75C10.5187 3.75 10.92 4.16797 10.92 4.6875V10ZM19.62 10C19.62 15.5234 15.3225 20 10.02 20C4.71748 20 0.419983 15.5234 0.419983 10C0.419983 4.47656 4.71748 0 10.02 0C15.3225 0 19.62 4.47656 19.62 10ZM10.02 1.875C5.71123 1.875 2.21998 5.51172 2.21998 10C2.21998 14.4883 5.71123 18.125 10.02 18.125C14.3287 18.125 17.82 14.4883 17.82 10C17.82 5.51172 14.3287 1.875 10.02 1.875Z",
    fill: "#003087"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMarcao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Marcação.149cfd62.svg";
export { ForwardRef as ReactComponent };